import { IStackStyles, IStackTokens } from "@fluentui/react";
import React from "react";

export const stackTokens: IStackTokens = { childrenGap: 10 };

export const labelStyles: IStackStyles = {
  root: {
    label: {
      foreGroundColor: "#747372"
    }
  }
};

export const IconPositionStyles = {
  display: "flex",
  alignItems: "center"
};

export const shimmerStyle = {
  marginTop: 10,
  width: 90,
  paddingLeft: 5
};

export const shimmerLoadStyle = {
  marginTop: 10,
  width: 95,
  paddingLeft: 4,
  paddingRight: 2
};

export const shimmerFlexStyle = {
  marginTop: 10,
  flex: 1,
  paddingLeft: 4,
  paddingRight: 3
};

export const titleStyle = {
  width: "90px"
};

export const wordWrapStyle: React.CSSProperties = {
  overflowWrap: "break-word", // Updated to use overflowWrap
  whiteSpace: "normal"
};

export const linkStyle = {
  marginBottom: "-7px"
};

export const containerStyle = {
  lineHeight: 2,
  minWidth: 300,
  paddingLeft: 15,
  paddingRight: 7
};

export const domainCountContainerStyle = {
  lineHeight: 2,
  maxWidth: 150,
  minWidth: 150,
  paddingLeft: 15
};
